import { DOCUMENT } from '@angular/common';
import { Component, Inject, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Device } from 'projects/common/model/Device';
import { Currency } from 'projects/common/model/landingModel';
import { AbstractComponent } from '../../abstract.component';
import { OfferCardData } from "../offer-card-data.model";
import { LoyaltyService } from '@shopping-angular-components/loyalty'
import { Module } from 'projects/common/model/ModuleModel';


interface ClusterData {
  offer: OfferCardData;
  tag: string;
}
export interface ClusterModule extends Module<ClusterData[]> {
  sbox_autocomplete?: boolean;
}

@Component({
  selector: 'clusters',
  template: `
    <text class="-eva-3-mb-md" [data]="module"></text>
    <div class="clusters-container">
      <div class="cluster-offer-container" *ngFor="let cluster of module.data; let i = index">
        <cluster *ngIf="i < MAX_CLUSTERS || otherRowsVisible" [data]="cluster.offer" [clusterTag]="cluster.tag" [locale]="locale"
          [loyaltyMode]="loyaltyService.mode$ | async" [index]="i" [moduleId]="module.id" [moduleIndex]="module.row_number"  [uniqueId]="module.unique_id"
          [currency]="currency" [flow]="flow" [device]="device" [sboxAutocomplete]="module.sbox_autocomplete"></cluster>
      </div>
      <div class="see-more-clusters" *ngIf="module.data.length > MAX_CLUSTERS">
        <eva-button [options]="{ghost_button: true, type: '-default', size: '-md', link_text: ('offers.buttons.seeMoreOffers.' + !otherRowsVisible) | translate}"
              (clickEvent)="onSeeMoreClustersClick()" [moduleId]="module.id" [moduleIndex]="module.row_number" [uniqueId]="module.unique_id"></eva-button>
      </div>
    </div>
  `,
  styleUrls: ['./clusters.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ClustersComponent extends AbstractComponent implements OnInit {
  @Input() override module: ClusterModule;
  @Input() currency: Currency;
  @Input() device: Device;

  MAX_CLUSTERS = 4;
  otherRowsVisible = false;
  locale: string;

  constructor(injector: Injector, @Inject(DOCUMENT) private document: Document, public loyaltyService: LoyaltyService) {
    super(injector);
  }

  ngOnInit(): void {
    const landingModel = this.landingModelService.getLandingModel();
    this.locale = landingModel.language + '_' + landingModel.country;
  }

  onSeeMoreClustersClick(): void {
    this.otherRowsVisible = !this.otherRowsVisible;
  }

  getModuleId(): string {
    return this.module.id;
  }
}
